<div class="page-layout">

  <app-profile-header></app-profile-header>


  <div

    [ngClass]="{'hideSPA': showSPA == false}"

    class="d-flex flex-column flex-grow-1"

    [attr.appVersion]="appVersion"

    role="main">


    <div

      class="d-flex justify-content-center flex-grow-1 flex-shrink-1 flex-basis-auto mt-76"

      [ngClass]="languageClass">


      <div

        [ngClass]="(headerState$ | async)?.class"

        class="app-container w-100">


        <div class="profile-shell-wrapper">


          <div class="p-24" [ngClass]="addCss">


            @if (isIframe) {

              <div class="modal-close-row">

                <div class="modal-close">

                  <button

                    ds-button=""

                    variant="icon"

                    class="ds-modal__closeButton ds-button ds-corners ds-pointer text-center mw-100 -icon d-inline-flex justify-content-center align-items-center -large"

                    [attr.title]="'rogers.modalCoseBtn' | translate"

                    tabindex="0"

                    (click)="closeModal()">


                    <ds-icon

                      class="-size-24"

                      name="close"

                      caption="Attention">

                    </ds-icon>


                  </button>

                </div>

              </div>

            }


@if (showHeaderBackground) {


  <div class="d-flex justify-content-end align-items-center">


    @if (showLang) {

      <div>

        @if ((!isIframe) && !hideLangToggle) {

          <button

            ds-button

            variant="tertiary"

            [attr.title]="'common.' + toggleLangText | translate"

            [attr.aria-label]="'common.' + toggleLangText | translate"

            (click)="languageToggle()">


            {{ toggleLangText | uppercase }}


          </button>

        }

      </div>

    }


  </div>


}


            <div class="profile-layout">


              <aside class="profile-layout__nav">


                <button

                  class="profile-nav-item"

                  (click)="navigate('overview')">

                  Profile Overview

                </button>


                <button

                  class="profile-nav-item"

                  (click)="navigate('username')">

                  Username

                </button>


                <button

                  class="profile-nav-item"

                  (click)="navigate('password')">

                  Password

                </button>


                <button

                  class="profile-nav-item"

                  (click)="navigate('recovery-number')">

                  Recovery Number

                </button>


                <button

                  class="profile-nav-item"

                  (click)="navigate('mfa')">

                  MFA

                </button>


                <button

                  class="profile-nav-item"

                  (click)="navigate('passkeys')">

                  Passkeys

                </button>


              </aside>


              <section class="profile-layout__content">


                <div

                  #transmitContainer

                  id="transmitContainer">

                </div>


              </section>


            </div>


          </div>


        </div>


      </div>


    </div>


  </div>


  <app-profile-footer></app-profile-footer>


</div>